<router-outlet></router-outlet>
<app-loader *ngIf="loading"></app-loader>
